import React, { createContext, useState } from 'react';

interface BlogWriterContextType {
  isStylesOpen: boolean;
  setIsStylesOpen: (open: boolean) => void;
}

export const BlogWriterContext = createContext<BlogWriterContextType>({
  isStylesOpen: false,
  setIsStylesOpen: () => {},
});

export function BlogWriterProvider({ children }: { children: React.ReactNode }) {
  const [isStylesOpen, setIsStylesOpen] = useState(false);

  return (
    <BlogWriterContext.Provider 
      value={{
        isStylesOpen,
        setIsStylesOpen,
      }}
    >
      {children}
    </BlogWriterContext.Provider>
  );
}